import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CmsService } from '@spartacus/core';
import { CmsComponentData, PageComponentModule } from '@spartacus/storefront';
import { filter, map, Observable } from 'rxjs';
import { InteractiveCarouselLoadingStrategyService } from '../interactive-carousel/interactive-carousel-loading-strategy.service';
import { InteractiveCarouselModule } from '../interactive-carousel/interactive-carousel.module';

export interface GgMainIntroSliderComponent {
  uid: string;
  items: string;
}

@Component({
  selector: 'app-gg-main-intro-slider',
  templateUrl: 'gg-main-intro-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PageComponentModule, InteractiveCarouselModule],
})
export class GgMainIntroSliderComponent implements OnInit, OnDestroy {
  private componentData = inject(CmsComponentData<GgMainIntroSliderComponent>);
  private cmsService = inject(CmsService);
  private loadingStrategyService = inject(InteractiveCarouselLoadingStrategyService);
  private destroyRef = inject(DestroyRef);

  private eagerItemsCount = 1; // How many items should be loaded eagerly

  private readonly componentData$: Observable<GgMainIntroSliderComponent> = this.componentData.data$.pipe(
    filter(Boolean)
  );

  private readonly items$: Observable<Observable<any>[]> = this.componentData$.pipe(
    map((data) => data.items?.trim().split(' ') || []),
    map((uids) => uids.map((uid) => this.cmsService.getComponentData(uid)))
  );

  ngOnInit(): void {
    this.loadingStrategyService.reset();

    this.componentData$
      .pipe(
        filter((data) => !!data.items),
        map((data) => data.items.trim().split(' ')),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((itemUids) => {
        this.loadingStrategyService.setEagerItems(itemUids.slice(0, this.eagerItemsCount));
      });
  }

  ngOnDestroy(): void {
    this.loadingStrategyService.reset();
  }

  getItems(): Observable<Observable<any>[]> {
    return this.items$;
  }
}
